class CareerNav {
  constructor() {
    if (document.querySelector(".career-hero")) {
      this.listen();
    }
  }

  listen() {
    const nav = document.querySelector(".career-nav");
    const parent = document.querySelector(".career-hero__body");
    const placeholder = document.querySelector(".career-nav--placeholder");
    placeholder.style.height = nav.scrollHeight + "px";
    placeholder.style.width =
      Math.min(nav.scrollWidth, window.innerWidth) + "px";

    // Nav-bar movement
    const movementObserver = new IntersectionObserver((entries) => {
      nav.classList.toggle("career-nav--fixed", !entries[0].isIntersecting);
      placeholder.classList.toggle(
        "career-nav--placeholder--fixed",
        !entries[0].isIntersecting
      );
    });
    movementObserver.observe(parent);

    // Nav colors
    let prevY = 0;
    let rootMargin = "0px 0px -95% 0px";
    const colorObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          let currentY = document.documentElement.scrollTop;
          if (currentY === prevY) return;

          if (currentY > prevY) {
            if (entry.intersectionRatio < 0.25 && entry.isIntersecting) {
              if (entry.target.dataset.bg === "dark") {
                nav.classList.add("career-nav--dark");
              }
              if (entry.target.dataset.bg === "light") {
                nav.classList.remove("career-nav--dark");
              }
            }
          } else {
            rootMargin = "0px 0px 95% 0px";
            if (entry.intersectionRatio < 0.25 && entry.isIntersecting) {
              if (entry.target.dataset.bg === "dark") {
                nav.classList.add("career-nav--dark");
              }
              if (entry.target.dataset.bg === "light") {
                nav.classList.remove("career-nav--dark");
              }
            }
          }
          prevY = currentY;
        });
      },
      {
        root: null,
        rootMargin: rootMargin,
        threshold: [0, 0.25, 0.5, 0.75, 1],
      }
    );

    const sections = document.querySelectorAll("main section");
    sections.forEach((section) => {
      colorObserver.observe(section);
    });
  }
}

export default CareerNav;
